var $toggler = $('[data-toggle]'),
  $togglerMenu = $('[data-toggle="menu-mobile"]'),
  $mainMenuMob = $('.main-menu-mobile'),
  $searchContainerMob = $('.support-menu-search-field-mobile'),
  $overlay = $('.menu-overlay');

//toggle mobil menu
$toggler.on('click', function(e) {
  e.preventDefault();
  var $this = $(this),
    toggleVal = $this.data('toggle');

  if (toggleVal === 'header-menu') {
    $togglerMenu.toggleClass('is-active');
    $mainMenuMob.toggleClass('is-open');
    $searchContainerMob.removeClass('is-open');
    $overlay.removeClass('is-open');
  }

  if (toggleVal === 'main-search') {
    var $searchContainer = $('.support-menu-search-field'),
      $searchField = $('.support-menu-search');

    $this.toggleClass('is-active');
    $this.next($searchContainer).toggleClass('is-open');

    if ($searchContainer.has('is-open')) {
      $searchField.focus();
    }
  }

  // cart button mobile
  if (toggleVal === 'shopping-cart') {
    $mainMenuMob.removeClass('is-active');
    $togglerMenu.removeClass('is-active');
    $mainMenuMob.removeClass('is-open');
    $searchContainerMob.removeClass('is-open');
    $overlay.removeClass('is-open');
  }

  // search button mobile
  if (toggleVal === 'main-search-mobile') {
    var $searchFieldMob = $('.support-menu-search-mobile');

    $togglerMenu.removeClass('is-active');
    $mainMenuMob.removeClass('is-open');

    $this.toggleClass('is-active');
    $searchContainerMob.toggleClass('is-open');
    $overlay.toggleClass('is-open');

    if ($searchContainerMob.has('is-open')) {
      $searchFieldMob.focus();
    }
  }

  // overlay button mobile
  if (toggleVal === 'overlay') {
    if ($overlay.hasClass('is-open')) {
      $overlay.removeClass('is-open');
      $searchContainerMob.removeClass('is-open');
    }
  }

  // accordion button
  if (toggleVal === 'accordion') {
    $this.toggleClass('is-open');
  }
});
